module.exports = __webpack_public_path__ + "static/media/mx.33c30b31.svg";